import React, { useEffect, useState } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { Home } from './components/Home';
import Login from "./components/Login";
import Category from "./components/Category";
import Products from "./components/Products";
import {NotFound} from "./components/NotFound";
import Sets from './components/Sets';
import MovementMaterials from './components/MovementMaterials';
import StockMaterials from './components/StockMaterials';
import AccountingMovement from './components/AccountingMovement';
import Account from './components/Account';
import CostMovements from './components/CostMovements';
import CostCenter from './components/CostCenter';
import StorageLocation from './components/StorageLocation';

import Layout from "./components/Layout";
import LoginLayout from "./components/LoginLayout";
import ProtectedRoute from './components/common/protectedRoute';
import Users from './components/Users';
import Movements from './components/Movements';
import Templates from './components/Templates';
import NotificationsContext from './context/notificationsContext';
import { HubConnectionBuilder } from "@microsoft/signalr";

function App() {
  const [connection, setConnection] = useState(null);
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
      const newConnection = new HubConnectionBuilder()
          .withUrl("/notifications", { accessTokenFactory: () => localStorage.getItem("token") })
          .withAutomaticReconnect()
          .build();

      setConnection(newConnection);
  }, []);

  useEffect(() => {
      if (!connection) return;

      connection.start()
        .then(() => {
            // On new notification
            connection.on('send', notification => {
              setNotifications(prev => [...prev, JSON.parse(notification)]);
            });

            // On notification read or unread
            connection.on("read", ({ id, isRead }) => {
              setNotifications(prev => prev.map(n => n.id === id ? { ...n, isRead: isRead } : n));
            });
        })
        .catch(e => console.error('Unable to connect to notifications hub.', e));
  }, [connection]);

  return (<NotificationsContext.Provider value={{
    notifications: notifications,
    setNotifications: setNotifications
  }}>
    <Switch>
      <ProtectedRoute path="/gralta/catalogos/categorias" render={() => <Layout><Category/></Layout>} />
      <ProtectedRoute path="/gralta/catalogos/productos" render={() => <Layout><Products/></Layout>} />
      <ProtectedRoute path="/gralta/catalogos/paquetes" render={() => <Layout><Sets/></Layout>} />
      <ProtectedRoute path="/gralta/catalogos/almacenes" render={() => <Layout><StorageLocation/></Layout>} />
      <ProtectedRoute path="/gralta/reportes/movimientosMateriales" render={() => <Layout><MovementMaterials/></Layout>} />
      <ProtectedRoute path="/gralta/reportes/inventario" render={() => <Layout><StockMaterials/></Layout>} />
      <ProtectedRoute path="/gralta/reportes/movimientosContables" render={() => <Layout><AccountingMovement/></Layout>} />
      <ProtectedRoute path="/gralta/reportes/cuentas" render={() => <Layout><Account/></Layout>} />
      <ProtectedRoute path="/gralta/reportes/movimientosCostos" render={() => <Layout><CostMovements/></Layout>} />
      <ProtectedRoute path="/gralta/reportes/centrosCosto" render={() => <Layout><CostCenter/></Layout>} />
      <Route path="/gralta/login" render={() => <LoginLayout><Login/></LoginLayout>} />
      <ProtectedRoute path="/gralta/movimientos" render={(props) => <Layout><Movements {...props} /></Layout>} />
      <ProtectedRoute path="/gralta/plantillas" render={() => <Layout><Templates/></Layout>} />
      <ProtectedRoute path="/gralta/usuarios" render={() => <Layout><Users/></Layout>} />
      <ProtectedRoute path="/gralta" render={() => <Layout><Home/></Layout>} />
      <Route path="/not-found" component={NotFound} />
      <Redirect to="/not-found" />
    </Switch>
  </NotificationsContext.Provider>);
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js